import React from "react";
import classNames from "classnames";
import Icon from "./Icon";
export default function(param) {
    var asset = param.asset, onToggle = param.onToggle, willBeDeleted = param.willBeDeleted;
    var isImage = !!asset.name.match(/\.(jpg|jpeg|png|gif|svg)$/gi);
    var classes = classNames("social-activity-editor__asset", {
        "social-activity-editor__asset--need-upload": asset.status === "pending",
        "social-activity-editor__asset--uploading": asset.status === "inprogress",
        "social-activity-editor__asset--finished": asset.status === "finished",
        "social-activity-editor__asset--will-be-deleted": willBeDeleted && asset.status !== "inprogress" && asset.status !== "finished"
    });
    var style = isImage ? {
        backgroundImage: "url(".concat(asset.tn_path || asset.path, ")")
    } : null;
    var circum = 2 * 13.5 * Math.PI;
    var iconName = null;
    if (willBeDeleted && asset.status !== "inprogress" && asset.status !== "finished") {
        iconName = "revert";
    } else if (!willBeDeleted && asset.status !== "inprogress" && asset.status !== "finished") {
        iconName = "delete";
    }
    return /*#__PURE__*/ React.createElement("a", {
        href: asset.path || "assets/images/placeholder.jpg",
        className: classes,
        onClick: function(evnt) {
            if (onToggle) {
                evnt.preventDefault();
                if (asset.status !== "inprogress" && asset.status !== "finished") {
                    onToggle(asset);
                }
            }
        },
        title: asset.name,
        style: style,
        key: asset.id
    }, !isImage && asset.name, iconName && /*#__PURE__*/ React.createElement(Icon, {
        name: iconName,
        size: "m",
        className: "social-activity-editor__asset__icon"
    }), asset.status === "inprogress" && /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "40",
        height: "40",
        className: "social-activity-editor__asset__svg"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("circle", {
        className: "social-activity-editor__asset__progress",
        r: "13.5px",
        cx: "20",
        cy: "20",
        fill: "transparent"
    })), /*#__PURE__*/ React.createElement("g", {
        "data-id": "UIProgressBarFill"
    }, /*#__PURE__*/ React.createElement("circle", {
        className: "social-activity-editor__asset__progress-fill",
        r: "13.5px",
        cx: "20",
        cy: "20",
        fill: "transparent",
        strokeDasharray: "".concat(circum, "px"),
        strokeDashoffset: "".concat(circum - circum / 100 * asset.progress, "px")
    }))));
};
